module.exports = __webpack_public_path__ + "img/4.347225df.jpeg";